import React, { useState } from "react";
import "./index.scss";
import tick from "assets/images/tick.svg";
import rightIcon from "assets/images/right.svg";
import SectionOne from "../Summary";

export default function IncludedServicesSection({ onNext, afsData, lead }) {
  const { flatfee = 0, installmentFee = 0.0, courtFee = 0.0 } = afsData || {};
  const quoteNumber = lead?.quoteNumber || "N/A";
  const totalflatfee = flatfee + installmentFee;

  const services = [
    "Negotiate the best result available to save you as much money as we can",
    "Protect Client from Default judgment by Responding to the Court",
    "Advice and counseling by Attorney via telephone or email/message",
    "Communication with opposing counsel",
    "Demand information from the debt collector (Demand for Production of Documents, Form and Special Interrogatories, Request for Admissions, as needed)",
    "Prepare Client’s responses to Discovery demands which the debt collector might send to Client",
    "Deal with the judge for you (case management)",
    "Preparation for Trial if necessary (every case is different)",
    "We have got this handled! You can sit back and relax – but please respond when we reach out to you 🙂",
  ];

  const [userName, setUserName] = useState("");

  const handleInputChange = (e) => {
    setUserName(e.target.value);
  };

  const handleFinishClick = async () => {
    if (userName.trim()) {
      await onNext(userName.trim());
      window.location.href = `https://secure.lawpay.com/pages/fullmanfirm/operating?amount=${
        totalflatfee + courtFee
      }&reference=${quoteNumber}`;
    }
  };

  return (
    <div className="included-services">
      <div className="fee-breakdown__installments">
        <div className="fee-breakdown__installments-title">Almost Done!</div>
        <div className="fee-breakdown__installments-subtitle">
          On the next page, you'll be able to complete your signup by submitting
          payment. You can choose to <strong>pay the flat fee upfront</strong>{" "}
          or use one of our <strong>flexible Pay Later options </strong> —
          whichever works best for you.
        </div>
      </div>
      <div className="included-services_content">
        <div className="included-services_content__title">
          Included Services:
        </div>

        <ul className="included-services_content__list">
          {services.map((item, index) => (
            <li key={index} className="included-services_content__item">
              <span className="included-services_content__icon">
                <img src={tick} alt="included-services_content__icon__check" />
              </span>
              {item}
            </li>
          ))}
        </ul>
      </div>
      <SectionOne lead={lead} />

      <div className="included-services_content__gap"></div>

      <div className="included-services_content__terms">
        <div className="included-services_content__terms__alert">
          Please enter your full name below to agree to these terms. Your sign
          up for services will be complete after you enter your name and pay the
          flat fee shown above.
        </div>
        <div className="included-services_content__terms__agreement-row">
          <label className="included-services_content__agreement">
            I,
            <input
              type="text"
              name="userName"
              placeholder="Enter your name"
              value={userName}
              onChange={handleInputChange}
              required
              className="included-services_content__input"
            />
            , AGREE TO ABOVE TERMS.
          </label>
        </div>
        {/* <div className="included-services_content__terms__alert">
          ⚠️ Important: Your signup isn't complete until payment is submitted on
          the next page. We won’t be able to begin work on your case until
          payment is received.
        </div> */}
        {/* <div style={{ height: "2rem" }}></div> */}
        <div className="included-services_content__terms__button-row">
          <button
            className="included-services_content__terms__button-row__button"
            disabled={!userName.trim()}
            onClick={handleFinishClick}
          >
            FINISH & PROCEED TO PAYMENT
            <img src={rightIcon} alt="Right Arrow" />
          </button>
        </div>

        {/* <a href="tel:+18772272872" className="included-services_content__chat">
          📞 Want to talk now?
        </a> */}
        <a href="tel:+18772272872" className="call-button" title="Call Now">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            fill="white"
            viewBox="0 0 24 24"
          >
            <path d="M6.62 10.79a15.053 15.053 0 006.59 6.59l2.2-2.2a1.003 1.003 0 011.11-.21c1.21.49 2.53.76 3.89.76a1 1 0 011 1V20a1 1 0 01-1 1c-9.39 0-17-7.61-17-17a1 1 0 011-1h3.5a1 1 0 011 1c0 1.36.26 2.68.76 3.89a1 1 0 01-.21 1.11l-2.2 2.2z" />
          </svg>
        </a>
      </div>
    </div>
  );
}
